/*
 * @Author: bbqin
 * @Date: 2023-02-14 15:10:49
 * @LastEditTime: 2023-07-26 15:24:27
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\components\card\load.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from "react";
import { loadJS } from '@platform/api';
import Skeleton from "../skeleton";
import EmptyPrompt from "../empty";

const BaseURL = '../../../../';
export default class Load extends Component {
    constructor(props) {
        super(props);
        this.state = {
            component: null,
            path: '',
            showSkeleton: false,
            preset: false,
        };
    }

    componentDidMount() {
        this.createScript(this.props.path);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.path !== nextProps.path) {
            this.createScript(nextProps.path);
        }
    }

    componentWillUnmount() {
        // 移除事件监听
        if (this.script) {
            this.script.removeEventListener('load', this.a);
            this.script.removeEventListener('error', this.b);
            delete this.a;
            delete this.b;
            delete this.script;
        }

        this.instance = null;
    }

    getComponentNameSpace = path => {
        var s = path.split('/'),
            componentNameSpace;
        componentNameSpace = s.slice(s.length - 5).join('/');
        componentNameSpace.includes('.js') && (componentNameSpace = componentNameSpace.substring(0, componentNameSpace.length - 3));
        return componentNameSpace;
    };

    createScript = src => {
        let { componentNameSpace = '' } = this.props;
        let that = this;
        if (src) {
            // 完整地址
            if (src.includes(BaseURL)) {
                if (!componentNameSpace) {
                    componentNameSpace = src.replace(BaseURL, '');
                    componentNameSpace = componentNameSpace.replace('.js', '');
                }
                componentNameSpace = componentNameSpace.replace(BaseURL);

                if (window[componentNameSpace]) {
                    let component = window[componentNameSpace].default;
                    this.setState({ component, preset: true });
                } else {
                    // 显示骨架图
                    this.setState({ showSkeleton: true });
                    // 加载js
                    loadJS(
                        src,
                        () => {
                            this.setState({ showSkeleton: false });
                            try {
                                let component = window[componentNameSpace].default;
                                this.setState({ component, preset: true });
                            } catch (e) {
                                console.log(e);
                            }
                        },
                        () => {
                            this.setState({ showSkeleton: false });
                            this.handError(src);
                        },
                    );
                }
            } else {
                let scripts = Array.from(document.getElementsByTagName('script')),
                    flag;
                componentNameSpace = this.getComponentNameSpace(src);
                flag = scripts.find(e => {
                    return e.src.includes(componentNameSpace);
                });
                this.a = this.handleLoad.bind(null, componentNameSpace, true);
                this.b = this.handError.bind(null, src);
                if (window[componentNameSpace]) {
                    // 已经加载过script标签
                    this.handleLoad(componentNameSpace);
                } else {

                    // 加载js
                    let script;
                    if (flag) {
                        script = flag;
                    } else {
                        // 显示骨架图
                        this.setState({ showSkeleton: true });

                        script = document.createElement('script');
                        script.src = BaseURL + componentNameSpace + '.js';
                        script.type = 'text/javascript';
                        document.body.appendChild(script);
                    }
                    this.script = script;
                    script.addEventListener('load', this.a);
                    script.addEventListener('error', this.b);

                }
            }
        }
    };

    handError = src => {
        this.setState({ showSkeleton: false });
        console.error(`找不到${src}这个文件，请检查引用路径`);
    }

    handleLoad = (componentNameSpace, async = false) => {
        let that = this;
        this.setState({ showSkeleton: false });
        try {
            if (!(async && componentNameSpace !== that.getComponentNameSpace(that.props.path))) {
                that.setState({ component: window[componentNameSpace].default });
            }
        } catch (e) {
            console.error(e.message);
            console.error(`请检查引用的${that.props.path}这个文件是源码还是编译好的。源码需要在config.json/buildEntryPath配相应的路径，编译好的则不用`);
        }
    };

    render() {
        let App = this.state.component;
        let {
            getInstance, pageInstance, path,
            __componentName,
            ___test,
            __langJson,
            portalPageInstance,
            ...others
        } = this.props;

        const showSkeleton = this.state.showSkeleton;

        if (showSkeleton) {
            return <div className="component-load-skeleton"><Skeleton active loading={showSkeleton} /></div>;
        }

        if (!App) {
            const img = <i className="component-load-fail-img" />;
            // __componentName
            return <div className="component-load-fail">
                <EmptyPrompt text={__langJson['card-load-fail']} img={img} />
            </div>;
        }

        if (this.state.preset) {
            others._this = { props: portalPageInstance || pageInstance };
        }

        return <App
            ref={dom => {
                this.instance = dom;
            }}
            getInstance={instance => {
                getInstance && getInstance(instance);
            }}
            parentPageInstance={portalPageInstance || pageInstance}
            {...others}
        />;
    }
}
